import { useQuery } from '@tanstack/react-query';
import { mediaKitsApi } from '~/api/mediaKits';
import { MEDIA_KIT } from '~/queries/keys';
import { AnyBlock } from '~/screens/PageBuilder/types';

export type MediaKit = {
  id: string;
  created_at: string;
  updated_at: string;
  name: string;
  agency_id: string;
  is_public: boolean;
  contact: {
    manager_email: string;
    manager_name: string;
    user_id: string;
  };
  created_by: { manager_name: string; manager_email: string; user_id: string };
  blocks: AnyBlock[];
  thumbnail?: string;
};

// Useful for preloading media kits
export const getMKQueryKeyFn = (id: string) => {
  return {
    queryKey: [MEDIA_KIT, { id }],
    queryFn: () =>
      mediaKitsApi.get(`/custom-shareable/${id}`).then((r) => r.data),
  };
};

export const useGetMediaKit = ({ id }: { id: string }) => {
  return useQuery<MediaKit>({
    ...getMKQueryKeyFn(id),
    enabled: Boolean(id),
    retry: 0,
  });
};
